// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__2IiA7","detailsBorder":"styles_detailsBorder__27ASq"};